import { ReplaySubject, Observable } from 'rxjs';

export class AppScriptLoader {
    private static _instance: AppScriptLoader;
    public static get Instance(): AppScriptLoader {
        if (!this._instance) this._instance = new AppScriptLoader();
        return this._instance;
    }

    private _loadedLibraries: { [url: string]: ReplaySubject<void> } = {};

    private constructor() {}

    get document(): Document {
        return window.document;
    }

    loadScript(url: string): Observable<void> {
        const lib = this._loadedLibraries;
        if (lib[url]) {
            return lib[url].asObservable();
        }

        lib[url] = new ReplaySubject();

        const script = this.document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = url;
        script.onload = () => {
            lib[url].next();
            lib[url].complete();
        };

        this.document.body.appendChild(script);

        return lib[url].asObservable();
    }

    loadStyle(url: string): Observable<void> {
        const lib = this._loadedLibraries;
        if (lib[url]) {
            return lib[url].asObservable();
        }

        lib[url] = new ReplaySubject();

        const style = this.document.createElement('link');
        style.type = 'text/css';
        style.href = url;
        style.rel = 'stylesheet';
        style.onload = () => {
            lib[url].next();
            lib[url].complete();
        };

        const head = this.document.getElementsByTagName('head')[0];
        head.appendChild(style);

        return lib[url].asObservable();
    }
}
